import React from 'react';

const PlatformDetails = ({ platform, gameId, details = {} }) => {
  return (
    <ul>
      {Object.keys(details).map((detailsKey) =>
        details[detailsKey] && <li key={`${gameId}_${platform}_${detailsKey}`}>
          <strong>{detailsKey}:</strong> {details[detailsKey]}
        </li>
      )}
    </ul>
  )
}

export default PlatformDetails
